import { createRoot } from "react-dom/client";
import { StrictMode } from "react";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from "react-router-dom";
import { Provider as ReduxProvider } from "react-redux";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV2";

import { StyledEngineProvider } from "@mui/material/styles";
import "nprogress/nprogress.css";
import App from "./App";
import { AuthProvider } from "./contexts/JWTContext";
import store from "./store";
// import { SettingsProvider } from "./contexts/SettingsContext";
// import { FirestoreProvider } from "./contexts/FirebaseFirestoreContext";

if (process.env.REACT_APP_ENV === "prod") console.log = function noConsole() {};

const root = createRoot(document.getElementById("root"));

root.render(
  <StrictMode>
    <HelmetProvider>
      <ReduxProvider store={store}>
        <StyledEngineProvider injectFirst>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <BrowserRouter>
              <AuthProvider>
                <App />
              </AuthProvider>
            </BrowserRouter>
          </LocalizationProvider>
        </StyledEngineProvider>
      </ReduxProvider>
    </HelmetProvider>
  </StrictMode>
);
